// Generated by CoffeeScript 2.7.0
export var SPELL_RULE_FIELDS = [
  {
    label: '中文',
    description: '张三',
    params: {
      proposer_attribute: 'name',
      rule: 'normal'
    }
  },
  {
    label: '全拼小写',
    description: 'zhangsan',
    params: {
      proposer_attribute: 'name',
      rule: 'full_lowercase'
    }
  },
  {
    label: '大驼峰',
    description: 'ZhangSan',
    params: {
      proposer_attribute: 'name',
      rule: 'full_big_camel_case'
    }
  },
  {
    label: '全拼大写',
    description: 'ZHANGSAN',
    params: {
      proposer_attribute: 'name',
      rule: 'full_capitalize'
    }
  },
  {
    label: '首字母大写',
    description: 'Zhangsan',
    params: {
      proposer_attribute: 'name',
      rule: 'full_title_upcase'
    }
  },
  {
    label: '小写分隔',
    description: 'zhang_san',
    params: {
      proposer_attribute: 'name',
      rule: 'full_snake_case'
    }
  },
  {
    label: '首字母缩写',
    description: 'ZS',
    params: {
      proposer_attribute: 'name',
      rule: 'acronym_upcase'
    }
  }
];

export var FIELD_GROUPS = [
  {
    label: '年月日',
    description: '20200101',
    params: {
      rule: '%Y%m%d'
    }
  },
  {
    label: '年月',
    description: '202001',
    params: {
      rule: '%Y%m'
    }
  },
  {
    label: '年',
    description: '2020',
    params: {
      rule: '%Y'
    }
  }
];
